import * as React from 'react';
import Modal from '../../../../../components/Modal';
import Button from '../../../../../components/Button';
import Loading from '../../../../../components/Loading';
import * as PropTypes from 'prop-types';
import { noop, isEmpty } from 'lodash';
import PreviewPdf from '../../../../Checks/components/PreviewReceipt';
import { reduxForm, Field } from 'redux-form/immutable';
import renderSelect from '../../../../../components/Select/reduxForm';
import renderField from '../../../../../components/Field/reduxForm';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getDictionaryCategories, dictionariesLoading } from '../../../../Checks/selectors';
import * as actionTypes from '../../../../Checks/actionTypes';
import { bindActionCreators } from 'redux';

const mapStateProps = createStructuredSelector({
  categoriesList: getDictionaryCategories,
  categoriesLoading: dictionariesLoading,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchCategories: () => ({ type: actionTypes.FETCH_ONLY_CATEGORIES }),
      dispatch,
    },
    dispatch,
  );

@connect(mapStateProps, mapDispatchToProps)
class SaveCheckModal extends React.Component {
  static propTypes = {
    handleClose: PropTypes.func.isRequired,
    checkData: PropTypes.any.isRequired,
    confirmError: PropTypes.string,
    draftError: PropTypes.any,
    loading: PropTypes.bool,
    handleSubmit: PropTypes.func.isRequired,
    categoriesList: PropTypes.array,
    fetchCategories: PropTypes.func,
    initialValues: PropTypes.any,
  };

  state = { showDependedFields: false };

  componentDidMount() {
    if (isEmpty(this.props.categoriesList)) {
      this.props.fetchCategories();
    }
  }

  getfetchCompletion = (isOk) => {
    this.setState({ showDependedFields: isOk });
  };

  getModalContent = () => {
    const { initialValues } = this.props;
    const id = initialValues.get('receiptId');
    return (
      <div>
        <form onSubmit={this.props.handleSubmit}>
          {this.props.confirmError && <p className="red">{this.props.confirmError}</p>}
          <PreviewPdf
            hasDownloadLink={false}
            record={{ id }}
            onFetchCompletion={this.getfetchCompletion}
            receiptBody={initialValues.get('receiptBody')}
          />

          {this.state.showDependedFields && (
            <>
              <div style={{ margin: '20px' }}>
                <Field
                  name={'description'}
                  tooltipContent={
                    <p>
                      Укажите любую полезную информацию по чеку: название организации, объект и цель
                      приобретения, потребителя услуги или период. Например: EnglishSchool, курсы
                      английского, сын Ваня, апрель 2019
                    </p>
                  }
                  normalize={(value) => value && value.replace(/;/g, '')}
                  component={renderField}
                  label={'Описание чека'}
                />

                <Field
                  name={'receiptCategory'}
                  component={renderSelect}
                  withoutHelpWrapper={false}
                  label={'Категория'}
                  tooltipTitle={null}
                  isFull={true}
                  tooltipContent={
                    <p>
                      Укажите категорию для удобства фильтрации и подбора чеков при оформлении
                      вычетов в 3-НДФЛ. Если ни одна из категорий не подошла, выберите «Прочее»
                    </p>
                  }
                  options={this.props.categoriesList}
                />
              </div>
              <div className="footer">
                <Button type="button" onClick={this.props.handleClose}>
                  Отменить
                </Button>
                <Button
                  onClick={noop}
                  isDisabled={this.props.loading}
                  color="orange"
                  buttonStyle={{ position: 'relative', minWidth: '140px' }}
                >
                  {this.props.loading ? <Loading isLight={true} /> : 'Сохранить'}
                </Button>
              </div>
            </>
          )}
        </form>
      </div>
    );
  };

  render() {
    return (
      <Modal showModal={true} onClose={this.props.handleClose}>
        {this.getModalContent()}
      </Modal>
    );
  }
}

export default reduxForm({
  form: 'confirmCheckForm',
})(SaveCheckModal);
